import { getApi, postApi } from 'apis';

interface IEarningDeductionItem {
	id: string;
	isChecked: boolean;
}

interface IEarningDeductionPayload {
	payGroupId: string;
	earningIds: IEarningDeductionItem[];
	deductionIds: IEarningDeductionItem[];
}

const getEmployee = async (data: any) => {
	return await getApi('/payGroup/employee', data);
};

const earningAndDeductionForPayGroupEmployees = async (
	data: IEarningDeductionPayload
) => {
	return await postApi('/payGroup/earning-deductions', data);
};

export const payGroup = {
	getEmployee,
	earningAndDeductionForPayGroupEmployees,
};
